<template>
  <div class="q-pa-md q-mt-lg">
    <q-table
      flat
      table-header-class="bg-accent text-width-bold"
      :title="
        'Posições estoque Destino' + ' ' + $store.state.org.unidadeData.nome
      "
      :rows="filteredRows"
      :columns="columns"
      class="tabela-tamanho-fixo"
      :loading="disable"
      hide-pagination
      dense
      :rows-per-page-options="[0]"
    >
      <template #top-right>
        <q-input
          dense
          outlined
          v-model="searchText"
          placeholder="Buscar"
          @update:model-value="searchLocalizacao"
          debounce="500"
          clearable
        >
          <template v-slot:append>
            <q-icon name="search" />
          </template>
        </q-input>
      </template>
      <template #body-cell-delete="props">
        <q-td>
          <q-btn
            @click="deleteId(props.row.id)"
            color="negative"
            round
            icon="delete"
          />
        </q-td>
      </template>
      <template #body-cell-total="props">
        <q-td>
          <q-input
            dense
            outlined
            v-model="props.row.destino"
            label="Quantidade"
          />
        </q-td>
      </template>
      <template #body-cell-selecione="props">
        <q-td>
          <q-radio v-model="selecionados" :val="props.row.id" />
        </q-td>
      </template>
    </q-table>
  </div>
</template>

<script>
const columns = [
  {
    name: "selecione",
    label: "Selecionar",
    field: "selecione",
    align: "left",
  },
  {
    name: "id",
    label: "ID",
    field: "id",
    align: "left",
  },
  {
    name: "nome",
    label: "Nome",
    field: "nome",
    align: "left",
  },
];

import { ref, onMounted, watch } from "vue";
import { useStore } from "vuex";
export default {
  props: ["atualizarDestino"],
  setup(props, { emit }) {
    const rows = ref([]);
    const filteredRows = ref([]);
    const disable = ref(true);
    const store = useStore();
    const selecionados = ref("");
    const searchText = ref("");

    const getData = async () => {
      try {
        const response = await store.dispatch("estoque/localizacao", {
          vendor_id: store.state.org.unidadeData.id,
        });

        rows.value = response.data.data;
        filteredRows.value = response.data.data;
        disable.value = false;
      } catch (error) {
        console.log(error);
      }
    };

    const searchLocalizacao = async () => {
      if (!searchText.value || searchText.value.trim() === "") {
        filteredRows.value = rows.value;
        return;
      }

      try {
        disable.value = true;
        const response = await store.dispatch("estoque/localizacao", {
          vendor_id: store.state.org.unidadeData.id,
          nome: searchText.value,
          per_page: 1000,
        });

        filteredRows.value = response.data.data;
        disable.value = false;
      } catch (error) {
        console.log(error);
        filteredRows.value = [];
        disable.value = false;
      }
    };

    onMounted(getData);

    watch(
      () => store.state.org.unidadeData,
      () => {
        searchText.value = "";
        getData();
      }
    );

    watch(
      () => selecionados.value,
      () => {
        emit("destino", selecionados.value);
      }
    );

    watch(
      () => props.atualizarDestino,
      () => {
        disable.value = true;
        searchText.value = "";
        getData();
      }
    );

    return {
      columns,
      rows,
      filteredRows,
      disable,
      getData,
      selecionados,
      searchText,
      searchLocalizacao,
    };
  },
};
</script>

<style></style>
